import { createRequest, RequestConfig } from 'app/common/api';

import { TTariffProfilesConstraints } from '../core/trip-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_tariff_profiles',
};

export const getTariffProfilesRequest = (
  constraints?: TTariffProfilesConstraints,
) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
